import { createContext, type ReactNode, useContext } from 'react';

interface ToroExtensionContext {
  isToroExtension: boolean;
  // Chrome extension release rendering this page, when known (passed in the iframe URL)
  extensionVersion: string | null;
}
const ToroExtensionContext = createContext<ToroExtensionContext>({
  isToroExtension: false,
  extensionVersion: null,
});
export function ToroExtensionContextWrapper({
  children,
  extensionVersion = null,
}: {
  children: ReactNode;
  extensionVersion?: string | null;
}) {
  return (
    <ToroExtensionContext.Provider value={{ isToroExtension: true, extensionVersion }}>
      {children}
    </ToroExtensionContext.Provider>
  );
}

export function useIsToroExtension() {
  return useContext(ToroExtensionContext).isToroExtension;
}

export function useToroExtensionVersion() {
  return useContext(ToroExtensionContext).extensionVersion;
}
